import { hasGlobalError } from '../shared';
const ERRORS = {
  INVALID_MOBILE: 'Invalid mobile number format'
};
export function isInvalidMobileError(error) {
  return hasGlobalError(error, ERRORS.INVALID_MOBILE);
}